export var name = "@atlaskit/editor-core";
export var version = "215.9.5";